import React from "react";
import { observer } from "mobx-react-lite";
import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";

function MultiChoiceBtnGroup(props) {
  return (
    <TextField
      id="outlined-basic"
      {...props}
      variant="outlined"
      style={{ width: "400px", margin: "1% 0" }}
      InputProps={{
        style: {
          fontSize: 14,
          height: 60,
        },
      }}
    />
  );
}

export default observer(MultiChoiceBtnGroup);
